export default {
  'Home': 'Home',
  'PODISMO': 'PODISMO',
  'CICLISMO': 'CICLISMO',
  'CICLISMO su STRADA': 'CYCLYNG',
  'ALTRISPORT': 'ALTRI SPORT',
  'TUTTI': 'TUTTI',


}
